import React, { useState } from "react";
import ReactMarkdown from "react-markdown";

const Card = (props) => {
  const [toggleModal, setToggleModal] = useState(false);
  const modal = (
    <div
      className={
        toggleModal
          ? props.data.medical
            ? "modal medical open"
            : "modal open"
          : props.data.medical
          ? "modal medical close"
          : "modal close"
      }
    >
      <div className="contents">
        <div className="modalTop">
          {props.data.logo ? (
            <img
              src={props.data.logo.url}
              className="modal-logo"
              alt={props.data.name ? props.data.name : null}
            />
          ) : (
            <div className="modal-instead-of-logo">NO IMAGE</div>
          )}
          <div className="info">
            <p className="copy">{props.data.copy ? props.data.copy : null}</p>
            <p className="industry-name">
              {props.data.industry.length
                ? props.data.industry.map((item, i, arr) => (
                    <span key={i} className="industry">
                      {item.industry}
                      {arr.length - 1 === i ? "" : ", "}
                    </span>
                  ))
                : null}
              <br />
              <span className="name">
                {props.data.name ? props.data.name : null}
              </span>
            </p>
          </div>
          {props.data.photo ? (
            <img
              src={props.data.photo.url}
              className="modal-photo"
              alt={props.data.name ? props.data.name : null}
            />
          ) : (
            <div className="modal-instead-of-photo">NO IMAGE</div>
          )}
        </div>
        <div className="modalBottom">
          <div className="modalLeft">
            <p className="description">
              {props.data.description ? props.data.description : null}
            </p>
            {props.data.recruitmentType ? (
              <p className="fl recruitmentType">
                <span className="mediumTitle">募集職種</span>
                <p>
                  <ReactMarkdown children={props.data.recruitmentType} />
                </p>
              </p>
            ) : null}
            {props.data.recruitmentType ? (
              <p className="fl license">
                <span className="mediumTitle">必要資格</span>
                <p>
                  <ReactMarkdown children={props.data.license} />
                </p>
              </p>
            ) : null}
            <p className="fl mt employmentStatus">
              <span className="mediumTitle">雇用形態</span>
              {props.data.employmentStatus.length
                ? props.data.employmentStatus.map((item, i, arr) => (
                    <span key="i">
                      {item.employmentStatus}
                      {arr.length - 1 === i ? "" : ", "}
                    </span>
                  ))
                : null}
            </p>
            {props.data.place ? (
              <p className="fl mt place">
                <span className="mediumTitle">勤務地</span>
                <p>{props.data.place}</p>
              </p>
            ) : null}
            {props.data.salary ? (
              <p className="fl mt salary">
                <span className="mediumTitle">給与</span>
                <p>
                  <ReactMarkdown children={props.data.salary} />
                </p>
              </p>
            ) : null}
            {props.data.treatment ? (
              <p className="fl mt treatment">
                <span className="mediumTitle">待遇</span>
                <p>{props.data.treatment}</p>
              </p>
            ) : null}
            {props.data.dayOff ? (
              <p className="fl mt dayOff">
                <span className="mediumTitle">休日</span>
                <p>{props.data.dayOff}</p>
              </p>
            ) : null}
            {props.data.note ? (
              <p className="fl mt note">
                <span className="mediumTitle">備考</span>
                <p>{props.data.note}</p>
              </p>
            ) : null}
          </div>
          <div className="modalRight">
            {props.data.tel ? (
              <p className="fl tel">
                <span className="mediumTitle">電話番号</span>
                <p>{props.data.tel}</p>
              </p>
            ) : null}
            {props.data.fax ? (
              <p className="fl mt fax">
                <span className="mediumTitle">FAX</span>
                <p>{props.data.fax}</p>
              </p>
            ) : null}
            {props.data.mail ? (
              <p className="fl mt mail">
                <span className="mediumTitle">メールアドレス</span>
                <p>
                  <a href={`mailto:${props.data.mail}`}>{props.data.mail}</a>
                </p>
              </p>
            ) : null}
            <p className="fl mt address">
              <span className="mediumTitle">住所</span>
              <p>
                <a
                  href={props.data.map ? props.data.map : null}
                  target="_blank"
                  rel="noreferrer"
                >
                  {props.data.address ? props.data.address : null}
                  <i className="fas fa-external-link-alt"></i>
                </a>
              </p>
            </p>
            {props.data.access ? (
              <p className="fl mt access">
                <span className="mediumTitle">アクセス</span>
                <div>
                  <ReactMarkdown children={props.data.access} />
                </div>
              </p>
            ) : null}
            <div className="buttonContainer">
              {props.data.link ? (
                <a href={props.data.link} target="_blank" rel="noreferrer">
                  <button>
                    お問い合わせ / 直接応募
                    <i className="fas fa-external-link-alt"></i>
                  </button>
                </a>
              ) : (
                <button className="desable">
                  お問い合わせ / 直接応募
                  <i className="fas fa-external-link-alt"></i>
                </button>
              )}
              {props.data.url ? (
                <a href={props.data.url} target="_blank" rel="noreferrer">
                  <button>
                    ホームページ<i className="fas fa-external-link-alt"></i>
                  </button>
                </a>
              ) : (
                <button className="desable">
                  ホームページ<i className="fas fa-external-link-alt"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <button
        className="closeButton"
        onClick={() => {
          setToggleModal(false);
        }}
      >
        <i className="fas fa-times"></i>
      </button>
    </div>
  );

  return (
    <>
      <div
        className={toggleModal ? "modal-overlay open " : "modal-overlay close "}
        onClick={() => {
          setToggleModal(false);
        }}
      ></div>
      <div
        className={props.data.medical ? "companyCard medical" : "companyCard"}
        onClick={() => {
          setToggleModal(true);
        }}
      >
        {props.data.photo ? (
          <img
            src={props.data.photo.url}
            className="photo"
            alt={props.data.name ? props.data.name : null}
          />
        ) : (
          <div className="instead-of-photo">NO IMAGE</div>
        )}
        <div className="logo-industry">
          {props.data.logo ? (
            <img
              src={props.data.logo.url}
              className="logo"
              alt={props.data.name ? props.data.name : null}
            />
          ) : (
            <div className="instead-of-logo">NO IMAGE</div>
          )}
          <p className="industry-name">
            {props.data.industry.length
              ? props.data.industry.map((item, i, arr) => (
                  <span key={i} className="industry">
                    {item.industry}
                    {arr.length - 1 === i ? "" : ", "}
                  </span>
                ))
              : null}
            <br />
            <span className="name">
              {props.data.name ? props.data.name : null}
            </span>
          </p>
        </div>

        <p className="copy">{props.data.copy ? props.data.copy : null}</p>
        {props.data.recruitmentType ? (
          <p className="recruitmentType">
            <span className="mediumTitle">募集職種</span>
            <span>{props.data.recruitmentType}</span>
          </p>
        ) : null}
        <p className="employmentStatus">
          <span className="mediumTitle">雇用形態</span>
          {props.data.employmentStatus.length
            ? props.data.employmentStatus.map((item, i, arr) => (
                <span key="i">
                  {item.employmentStatus}
                  {arr.length - 1 === i ? "" : ", "}
                </span>
              ))
            : null}
        </p>
        <p className="description">
          {props.data.description ? props.data.description : null}
        </p>
        <div className="openButton">
          <i className="far fa-clipboard"></i>詳細
        </div>
      </div>

      {modal}
    </>
  );
};

export default Card;
